import { Component, OnInit } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { Helper } from '../../../helpers/helper';
import { PrestamosService } from '../../../services/prestamos.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { IMyDrpOptions, IMyDateSelected, IMyOptions } from 'mydaterangepicker';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { AlertasModales } from '../../../helpers/alertasModales';

@Component({
  selector: 'app-reporte-global-semanal',
  templateUrl: './reporte-global-semanal.component.html',
  styleUrls: ['./reporte-global-semanal.component.css']
})
export class ReporteGlobalSemanalComponent implements OnInit {

  loaded = false;
  loading = false;
  exportando = false;
  now = new Date(this.helper.getDate());
  starDate = new Date(this.helper.getDate());
  resOneWeek  = this.starDate.setTime(this.now.getTime() - (6 * 24 * 60 * 60 * 1000));
  myDateRangePickerOptions: IMyDrpOptions = {
    // other options...
    dateFormat: 'dd-mm-yyyy',
    showSelectDateText: true,
    selectBeginDateTxt : 'Seleccione la fecha inicial',
    selectEndDateTxt: 'Seleccione la fecha final',
    editableDateRangeField: false,
    showClearBtn: false,
    showApplyBtn: false,
    showClearDateRangeBtn: false
  };
  private model: any = {beginDate: {year: this.starDate.getFullYear(), month: this.starDate.getMonth() + 1, day: this.starDate.getDate()},
  endDate: {year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate()}};
  registros = [];
  entregado = 0;
  traido = 0;
  prestado = 0;
  gastos = 0;
  vencidos = 0;
  cobrado = 0;
  proyeccion = 0;
  proyeccionSiguiente = 0;
  configPdf;
  constructor(
    private helper: Helper,
    private prestamoService: PrestamosService,
    private route: ActivatedRoute,
    private router: Router,
    private empleadoService: EmpleadosServicio,
    private modals: AlertasModales) {
      if (this.empleadoService.datosEmpleado.tipo_empleado !== 3) {
        this.router.navigate(['/404']);
      }
      this.initConfigPdf();
    }

  ngOnInit() {
    this.verificarQueryString();
    this.myDateRangePickerOptions.disableSince = {year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate()};
  }

  private initReporte(): void {
    this.loading = true;
    this.prestamoService.obtenerReporteGlobalSemanal(this.model)
    .subscribe((res: any) => {
      this.registros = res;

      this.entregado = this.registros.reduce( (a, b) => a + b.dinero_entregado, 0);
      this.traido = this.registros.reduce( (a, b) => a + b.dinero_traido, 0);
      this.prestado = this.registros.reduce( (a, b) => a + b.prestado, 0);
      this.gastos = this.registros.reduce( (a, b) => a + b.gastos, 0);
      this.vencidos = this.registros.reduce( (a, b) => a + b.vencidos_total - b.pagos_prestamos_vencidos, 0);
      this.cobrado = this.registros.reduce( (a, b) => a + b.cobrado_ruteros, 0);
      this.proyeccion = this.registros.reduce( (a, b) => a + b.proyeccion_semana_actual, 0);
      this.proyeccionSiguiente = this.registros.reduce( (a, b) => a + b.proyeccion_proxima_semana, 0);

      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  filtrarReporte() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    const fecha_inicia = this.model.beginDate.year + '-' +
    (this.model.beginDate.month < 10 ?
      '0' + this.model.beginDate.month :
      this.model.beginDate.month) + '-' +

    (this.model.beginDate.day < 10 ?
      '0' + this.model.beginDate.day :
      this.model.beginDate.day);

    const fecha_termina = this.model.endDate.year + '-' +

    ( this.model.endDate.month < 10 ?
      '0' + this.model.endDate.month :
      this.model.endDate.month) + '-' +

    (this.model.endDate.day < 10 ?
      '0' + this.model.endDate.day :
      this.model.endDate.day);

    queryParams['fecha_inicia'] = fecha_inicia;
    queryParams['fecha_termina'] = fecha_termina;
    this.router.navigate(['./reporte-global-semanal'], { queryParams: queryParams });
    this.initReporte();
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.hasOwnProperty('fecha_inicia') && params.hasOwnProperty('fecha_termina')) {
          const fecha_inicia = new Date(params.fecha_inicia);
          const fecha_termina = new Date(params.fecha_termina);
          if (!isNaN(fecha_inicia.getTime()) && !isNaN(fecha_termina.getTime())) {
            // Set fecha inicia
            this.model.beginDate.year = fecha_inicia.getFullYear();
            this.model.beginDate.month = fecha_inicia.getMonth() + 1;
            this.model.beginDate.day = fecha_inicia.getDate() + 1;

            // Set fecha termina
            this.model.endDate.year = fecha_termina.getFullYear();
            this.model.endDate.month = fecha_termina.getMonth() + 1;
            this.model.endDate.day = fecha_termina.getDate() + 1;
          }
        }
        this.initReporte();
      }
    });
  }

  private initConfigPdf(): void {
    this.prestamoService.obtenerConfiguracionPrestamo()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.direccion
      };
    });
  }

  exportar() {
    // tslint:disable-next-line:max-line-length
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO === 1).length || this.empleadoService.datosEmpleado.tipo_empleado === 3) {

      if (!this.exportando && this.registros.length > 0) {
        this.exportando = true;
        const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];
        const fecha_inicia = [(this.model.beginDate.day < 10 ? '0' + this.model.beginDate.day : this.model.beginDate.day),
          (monthNames[this.model.beginDate.month - 1]),
          this.model.beginDate.year].join(' ');

        const fecha_termina = [(this.model.endDate.day < 10 ? '0' + this.model.endDate.day : this.model.endDate.day),
          (monthNames[this.model.endDate.month - 1]),
          this.model.endDate.year].join(' ');


        const title = `Reporte Semanal Global Desde ${fecha_inicia} hasta ${fecha_termina}`;
        const columns = [
          {title: 'Fecha', dataKey: '0'},
          {title: 'Ruta', dataKey: '1'},
          {title: '$ Entregado', dataKey: '2'},
          {title: '$ Traído', dataKey: '3'},
          {title: 'Prestado', dataKey: '4'},
          {title: 'Gastos', dataKey: '5'},
          {title: 'Vencidos', dataKey: '6'},
          {title: 'Cobrado', dataKey: '7'},
          {title: 'Proyección', dataKey: '8'},
          {title: 'Proyección siguiente', dataKey: '9'},
        ];
        const rows = [];
        const currencyPipe = new CurrencyPipe('en-US');
        const datePipe = new DatePipe('en-US');

          for (const row of this.registros) {
            rows.push(
              {
                '0': datePipe.transform(row.fecha_apertura, 'dd-MM-yyyy'),
                '1': row.ruta,
                '2': currencyPipe.transform(row.dinero_entregado),
                '3': currencyPipe.transform(row.dinero_traido),
                '4': currencyPipe.transform(row.prestado),
                '5': currencyPipe.transform(row.gastos),
                '6': currencyPipe.transform(row.vencidos_total - row.pagos_prestamos_vencidos),
                '7': currencyPipe.transform(row.cobrado_ruteros),
                '8': currencyPipe.transform(row.proyeccion_semana_actual),
                '9': currencyPipe.transform(row.proyeccion_proxima_semana)
              }
            );
          }

          // Add footer
          rows.push({
            '0': `Total:`,
            '2': currencyPipe.transform(this.entregado),
            '3': currencyPipe.transform(this.traido),
            '4': currencyPipe.transform(this.prestado),
            '5': currencyPipe.transform(this.gastos),
            '6': currencyPipe.transform(this.vencidos),
            '7': currencyPipe.transform(this.cobrado),
            '8': currencyPipe.transform(this.proyeccion),
            '9': currencyPipe.transform(this.proyeccionSiguiente)
          });

          const columnStyles = {
            // id: {fillColor: 255, textColor: 0}
          };
          const empleado = this.empleadoService.datosEmpleado.nombreCompleto;
          this.helper.exportarReportePdf(this.configPdf, title, columns, rows, empleado, columnStyles, 'l')
          .then(() => {
            this.exportando = false;
          })
          .catch(() => {
            this.exportando = false;
          });
      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
    }
  }
  onDateSelected(event: IMyDateSelected) {
    if ( event.type === 1 ) {
      this.disableUntil(event.date);
    } else {
      const copy = this.getCopyOfOptions();
      copy.disableSince = { day: 0, month: 0, year: 0};
      copy.disableUntil = { day: 0, month: 0, year: 0};
      this.myDateRangePickerOptions = copy;
    }
}

disableUntil(date) {
  const d: Date = new Date(date.year, date.month - 1, date.day );

  const copy = this.getCopyOfOptions();
  copy.disableUntil = {year: d.getFullYear(),
                           month: d.getMonth() + 1,
                           day: d.getDate()};
    // set next date
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
    copy.disableSince = {year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate()};
  this.myDateRangePickerOptions = copy;
}

getCopyOfOptions(): IMyOptions {
  return JSON.parse(JSON.stringify(this.myDateRangePickerOptions));
}
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/reporte-global-semanal/reporte-global-semanal.component.ts